<template>
  <v-container fluid class="politica-page pa-0">

    <!-- HEADER -->
    <div class="politica-header">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" class="text-center">
            <div class="politica-label">DOCUMENTO LEGAL</div>
            <h1 class="politica-title">Política de Privacidade</h1>
            <p class="politica-updated">Última atualização: abril de 2026</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- CONTEÚDO -->
    <v-container class="py-12">
      <v-row justify="center">
        <v-col cols="12" md="8">
          <div class="politica-body">

            <section class="politica-section">
              <h2 class="sec-title">1. Apresentação</h2>
              <p>
                A presente Política de Privacidade descreve como o <strong>CargasZap</strong>
                coleta, utiliza, armazena e protege os dados pessoais dos seus usuários, em
                conformidade com a <strong>Lei Geral de Proteção de Dados Pessoais
                (LGPD — Lei nº 13.709/2018)</strong> e demais normas brasileiras applicáveis.
              </p>
              <p>
                Ao utilizar o sistema, o usuário confirma que leu e concorda com esta Política.
                Caso não concorde, recomendamos que não utilize a plataforma.
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">2. Dados Coletados</h2>
              <p>Coletamos apenas os dados necessários para o funcionamento do serviço, incluindo:</p>
              <h3 class="subsec-title">Dados fornecidos pelo usuário</h3>
              <ul>
                <li>Nome completo;</li>
                <li>Endereço de e-mail;</li>
                <li>Senha (armazenada de forma criptografada);</li>
                <li>Dados da empresa (nome, CNPJ, quando aplicável);</li>
                <li>Dados de motoristas e veículos cadastrados na plataforma.</li>
              </ul>
              <h3 class="subsec-title">Dados coletados automaticamente</h3>
              <ul>
                <li>Endereço IP e informações do dispositivo de acesso;</li>
                <li>Logs de acesso e ações dentro do sistema (data, hora, operações realizadas);</li>
                <li>Cookies de sessão para manter o usuário autenticado.</li>
              </ul>
              <h3 class="subsec-title">Dados de terceiros</h3>
              <ul>
                <li>Quando o cadastro é realizado via Google, recebemos nome, e-mail e identificador
                  Google (sub), conforme autorizado pelo próprio usuário na tela de consentimento do Google.</li>
                <li>Números de WhatsApp dos motoristas, fornecidos pelo gestor para envio de alertas automáticos.</li>
              </ul>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">3. Finalidade do Tratamento</h2>
              <p>Os dados coletados são utilizados exclusivamente para:</p>
              <ul>
                <li>Autenticar o usuário e manter o acesso seguro ao sistema;</li>
                <li>Prestação dos serviços contratados (gestão de motoristas, veículos, financeiro e documentos);</li>
                <li>Envio de alertas automáticos de vencimento de documentos via WhatsApp;</li>
                <li>Recebimento de despesas lançadas por motoristas via WhatsApp;</li>
                <li>Comunicações sobre o serviço, como atualizações, manutenções e novidades;</li>
                <li>Cumprimento de obrigações legais e regulatórias;</li>
                <li>Melhoria contínua da plataforma com base em padrões de uso agregados e anônimos.</li>
              </ul>
              <p>
                <strong>Não utilizamos os dados para fins publicitários, venda a terceiros ou
                perfilamento comportamental.</strong>
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">4. Base Legal para o Tratamento</h2>
              <p>O tratamento dos dados pessoais se baseia nas seguintes hipóteses previstas na LGPD:</p>
              <ul>
                <li><strong>Execução de contrato</strong> (art. 7º, V) — para prestar os serviços contratados;</li>
                <li><strong>Consentimento</strong> (art. 7º, I) — para envio de comunicações e ao aceitar esta política;</li>
                <li><strong>Legítimo interesse</strong> (art. 7º, IX) — para melhoria do serviço e segurança da plataforma;</li>
                <li><strong>Cumprimento de obrigação legal</strong> (art. 7º, II) — quando exigido por lei ou autoridade competente.</li>
              </ul>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">5. Compartilhamento de Dados</h2>
              <p>
                Os dados dos usuários <strong>não são vendidos nem compartilhados com fins comerciais</strong>.
                O compartilhamento ocorre apenas nas seguintes situações:
              </p>
              <ul>
                <li><strong>Meta (WhatsApp)</strong> — para envio de mensagens automáticas aos motoristas, conforme
                  contratação da API oficial do WhatsApp Business;</li>
                <li><strong>Google</strong> — quando o usuário opta pelo login via Google, nos termos da política
                  de privacidade do Google;</li>
                <li><strong>Provedores de infraestrutura</strong> — servidores e serviços de hospedagem utilizados
                  para manter o sistema em funcionamento, sob termos de confidencialidade;</li>
                <li><strong>Autoridades públicas</strong> — quando exigido por lei, decisão judicial ou regulatória.</li>
              </ul>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">6. Retenção e Exclusão dos Dados</h2>
              <p>
                Os dados são mantidos pelo tempo necessário à prestação do serviço e pelo período
                exigido pela legislação brasileira aplicável (tributária, trabalhista e civil).
              </p>
              <p>
                Após o cancelamento da conta, os dados pessoais são excluídos ou anonimizados em
                até <strong>90 (noventa) dias</strong>, ressalvadas as hipóteses em que a lei exija
                retenção por prazo superior.
              </p>
              <p>
                Dados de logs de acesso são mantidos por, no mínimo, <strong>6 (seis) meses</strong>,
                conforme exige o Marco Civil da Internet (Lei nº 12.965/2014).
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">7. Segurança dos Dados</h2>
              <p>
                Adotamos medidas técnicas e organizacionais adequadas para proteger os dados pessoais
                contra acesso não autorizado, perda, alteração ou divulgação indevida, incluindo:
              </p>
              <ul>
                <li>Senhas armazenadas com hash criptográfico (bcrypt);</li>
                <li>Comunicação via HTTPS com certificado SSL/TLS;</li>
                <li>Controle de acesso por autenticação com token (JWT);</li>
                <li>Acesso restrito aos dados por nível de permissão dentro do sistema.</li>
              </ul>
              <p>
                Em caso de incidente de segurança que possa afetar dados pessoais, notificaremos
                os usuários afetados e a Autoridade Nacional de Proteção de Dados (ANPD) nos
                prazos previstos em lei.
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">8. Direitos do Titular dos Dados</h2>
              <p>
                Nos termos da LGPD, o usuário tem os seguintes direitos em relação aos seus dados:
              </p>
              <ul>
                <li><strong>Confirmação e acesso</strong> — saber quais dados possuímos sobre você;</li>
                <li><strong>Correção</strong> — solicitar a atualização de dados incorretos ou desatualizados;</li>
                <li><strong>Anonimização ou exclusão</strong> — solicitar a remoção de dados desnecessários;</li>
                <li><strong>Portabilidade</strong> — receber seus dados em formato estruturado;</li>
                <li><strong>Revogação do consentimento</strong> — retirar o consentimento dado anteriormente;</li>
                <li><strong>Oposição</strong> — contestar tratamentos realizados com base em legítimo interesse;</li>
                <li><strong>Informação sobre compartilhamento</strong> — saber com quais entidades seus dados foram compartilhados.</li>
              </ul>
              <p>
                Para exercer qualquer um desses direitos, entre em contato pelo WhatsApp ou e-mail
                disponível no site. Responderemos em até <strong>15 (quinze) dias úteis</strong>.
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">9. Cookies</h2>
              <p>
                O sistema utiliza cookies de sessão estritamente necessários para manter o usuário
                autenticado durante o uso da plataforma. Não utilizamos cookies de rastreamento,
                publicidade ou analytics de terceiros.
              </p>
              <p>
                O usuário pode configurar seu navegador para bloquear cookies, porém isso pode
                impedir o funcionamento correto do sistema.
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">10. Menores de Idade</h2>
              <p>
                O CargasZap é destinado exclusivamente a pessoas jurídicas e a maiores de 18 anos.
                Não coletamos intencionalmente dados de menores. Caso identificado cadastro nessa
                condição, os dados serão excluídos imediatamente.
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">11. Alterações nesta Política</h2>
              <p>
                Esta Política pode ser atualizada periodicamente. Modificações relevantes serão
                comunicadas via e-mail ou notificação dentro do sistema com antecedência mínima de
                <strong>15 (quinze) dias</strong>. O uso continuado após esse prazo implica
                aceitação das novas condições.
              </p>
            </section>

            <v-divider class="politica-divider" />

            <section class="politica-section">
              <h2 class="sec-title">12. Contato e Encarregado de Dados (DPO)</h2>
              <p>
                Para dúvidas, solicitações ou reclamações relacionadas ao tratamento de dados
                pessoais, o usuário pode entrar em contato pelo WhatsApp ou e-mail disponível
                no site.
              </p>
              <p>
                Também é possível registrar reclamações perante a
                <strong>Autoridade Nacional de Proteção de Dados (ANPD)</strong>
                pelo site <strong>gov.br/anpd</strong>.
              </p>
            </section>

          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>
</template>

<script>
export default {
  name: "PoliticaPage"
};
</script>

<style scoped>
.politica-page {
  background: radial-gradient(circle at top left, #0f172a, #020617);
  min-height: 100vh;
  color: #f1f5f9;
  font-family: "Inter", sans-serif;
}

.politica-header {
  background: linear-gradient(180deg, #0b1220 0%, transparent 100%);
  padding: 80px 0 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.politica-label {
  color: #10b981;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.politica-title {
  font-size: 42px;
  font-weight: 800;
  color: #f1f5f9;
  margin-bottom: 10px;
}

.politica-updated {
  color: #64748b;
  font-size: 13px;
}

.politica-body {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 48px 52px;
}

.politica-section {
  margin-bottom: 8px;
}

.sec-title {
  font-size: 17px;
  font-weight: 700;
  color: #10b981;
  margin-bottom: 14px;
}

.subsec-title {
  font-size: 14px;
  font-weight: 600;
  color: #cbd5e1;
  margin-top: 14px;
  margin-bottom: 8px;
}

.politica-body p {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 10px;
}

.politica-body ul {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.8;
  padding-left: 20px;
  margin-bottom: 10px;
}

.politica-body ul li {
  margin-bottom: 6px;
}

.politica-body strong {
  color: #f1f5f9;
}

.politica-divider {
  border-color: rgba(255, 255, 255, 0.06) !important;
  margin: 28px 0;
}

@media (max-width: 600px) {
  .politica-body {
    padding: 28px 20px;
  }

  .politica-title {
    font-size: 28px;
  }
}
</style>